import { EmptyState } from '../../ui';

/**
 * `runtime: 'engine'` and `'miniapp'` projects render through src/engine's React Native
 * components, which the browser deliberately does not ship. Saying so is better than an
 * empty pane that looks broken.
 */
export default function UnsupportedRuntime({ runtime }: { runtime: string }) {
  return (
    <EmptyState
      icon="myApps"
      title="Open this one on your phone"
      body={`This project uses the ${runtime} runtime, which only the Saddle app can render. Anything you build here in the browser opens as a web app.`}
    />
  );
}
